import { jwtDecode } from 'jwt-decode';

/** Synced with login API RestrictToBilling: expired / no active paid plan, or active trial. */
export const BILLING_ONLY_HOME = '/management/billing';

/**
 * Hydrates from JWT only when the key was never set (e.g. legacy session).
 * After the user upgrades, we set 'false' explicitly so a stale JWT does not re-lock the app until re-login.
 */
export function syncRestrictToBillingFromStoredToken(): void {
  if (localStorage.getItem('restrictToBilling') !== null) return;
  const token = localStorage.getItem('authToken');
  if (!token) return;
  try {
    const decoded = jwtDecode<{ restrictToBilling?: string }>(token);
    localStorage.setItem('restrictToBilling', decoded.restrictToBilling === 'true' ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

export function isBillingRestricted(): boolean {
  try {
    if (sessionStorage.getItem('impersonateToken')) {
      return sessionStorage.getItem('impersonateRestrictToBilling') === 'true';
    }
    return localStorage.getItem('restrictToBilling') === 'true';
  } catch {
    return false;
  }
}

/** When not restricted, always returns true. Whitelists billing, plan upgrade, and support (header ticket link). */
export function isPathAllowedDuringBillingRestriction(pathname: string): boolean {
  if (!isBillingRestricted()) return true;
  const normalized = (pathname || '/').replace(/\/+$/, '') || '/';
  const p = normalized.toLowerCase();
  if (p === '/management/billing') return true;
  if (p.startsWith('/management/billing/')) return true;
  if (p === '/subscriptions/upgrade') return true;
  if (p.startsWith('/subscriptions/upgrade/')) return true;
  if (p === '/support' || p.startsWith('/support/')) return true;
  return false;
}
